<!-- 专长页面 -->
<template>
  <div class="home animate__animated animate__fadeIn" ref="home">
    <div class="top">
      <Header />
    </div>
    <div class="banner">
      <div class="animate__animated animate__fadeInUp animate__faster">
        <span style="margin-bottom:20px">专长</span>
        <span>专家跨学科合作研发，高效、增值的创新型解决方案</span>
      </div>
    </div>
    <div class="main">
      <div class="main_center">
        <div class="bread">
          <span style="cursor:pointer" @click="handleHome">首页</span> > 专长
        </div>
        <!-- <div class="title">努力实现工业增长，同时注意生产率对环境的潜在影响</div>
        <div class="text">一切从客户需求出发，通过各类产品的灵动组织，帮助客户实现最优的生产方式和最大化的价值增长。</div>-->
        <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="综合介绍" name="first" class="animate__animated animate__fadeIn">
            <div class="container container1">
              <div class="title">跨学科的技术研发与生产应用</div>
              <div
                class="text"
              >我们核心研发团队源自美国哥伦比亚大学、清华大学、浙江大学等世界一流高校的研发中心，由知名科学家领衔，汇聚了计量、传感、能源、电气、机械、云计算、数字建模、算法等多个专业学科的资深工程师，通过跨学科的合作与技术研发，为能源计量、能耗分析、节能改造、以及物联网和工业大数据提供创新型解决方案，与服务客户共同打造更智能、更安全和更可持续发展的世界。</div>
              <div
                class="text"
              >我们聚焦中国“新基建”，持续在工业互联网、工业物联网、人工智能、智能制造等基础设施等重点领域进行战略布局，携手合作伙伴与客户，为工业变革升级注入持续动力。</div>
            </div>
            <ul class="ul1">
              <li
                v-for="(item,index) in imgList"
                :key="index"
                @mouseenter="handleEnter(index)"
                @mouseleave="handleLeave(index)"
                @click="handleClickTabs(index)"
              >
                <img v-bind:src="item.url" class="animate__animated" alt />
                <div class="name animate__animated animate__headShake" v-if="item.spanFlag">
                  <span>{{item.name}}</span>
                </div>
                <div class="mask animate__animated animate__fadeIn" v-if="item.maskFlag">
                  <div>
                    <span class="animate__animated animate__lightSpeedInLeft">{{item.name}}</span>
                    <span class="animate__animated animate__lightSpeedInLeft">{{item.content}}</span>
                  </div>
                </div>
              </li>
            </ul>
          </el-tab-pane>
          <el-tab-pane label="能源" name="second" class="animate__animated animate__fadeIn">
            <div class="container container2">
              <div class="title">
                从能源的测量、存储、使用等方面考量，
                <br />全方位降低能源成本
              </div>
              <div
                class="text"
              >身处现今严苛的经济形势中，大多数制造厂商都在不断设法降低成本。有远见的制造商更是早已拟妥整厂策略，实施能源管理，以降低单位生产的能耗。我们致力于整合工业应用中的软硬件装置，有效使用和监控能源，降低能源成本，优化能源效率，进而对能源管理策略产生帮助我们既可提供单一的测量设备，也能供应整套的能源方案，比如冷热水、压缩空气、天然气、电力及蒸汽管等公用工程的解决方案，实现企业能源管理目标。</div>
              <!-- 步骤 -->
              <div class="step">
                <div class="step_title">三个简单步骤，开启工厂能源变革</div>
                <div class="step_items">
                  <div class="step_item">
                    <span>01</span>
                    <img class="img1" src="@assets/img/shujv.png" alt />
                    <span>数据采集</span>
                    <span>使用能源数据采集软件，收集不同机台和设备的数据，并将数据传到运算平台，可根据需求选择储存于地端或云端平台。</span>
                  </div>
                  <div class="step_item">
                    <span class="shujv">02</span>
                    <img class="img2" src="@assets/img/yunsuan.png" alt />
                    <span class="shujv1">数据运算和可视化</span>
                    <span>从数据平台整合能源数据，进行能耗分析与可视化呈现。同时也可上传至云端平台做数据运用。</span>
                  </div>
                  <div class="step_item">
                    <span>03</span>
                    <img class="img3" src="@assets/img/guanli.png" alt />
                    <span>中央管理</span>
                    <span>透过可视化管理，不论是实时数据或历史数据，都可在大数据平台实现情景化与可视化的能耗指针信息，使管理人员展开一连串的节能行动。</span>
                  </div>
                </div>
              </div>
              <!-- 创新 -->
              <div class="innovate">
                <div class="innovate_title">创新整合，将能源管理数字化</div>
                <ul>
                  <li
                    v-for="(item,index) in innovateList"
                    :key="index"
                    v-bind:style="{ 'background-image': 'url(' + item.url+ ')','background-repeat':'no-repeat', 'background-position':' left center'}"
                  >
                    <!-- <div class="image">
                      <img :src="item.url" alt />
                    </div>-->
                    <div class="introduce">
                      <span class="theme" v-html="item.theme">{{item.theme}}</span>
                      <span class="content" v-html="item.content">{{item.content}}</span>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="step step1">
                <div class="step_items">
                  <div class="step_item">
                    <img class="img4" src="@assets/img/neng1.png" alt />
                    <span>提升效率</span>
                    <span>
                      工厂能源数据可视化
                      <br />预防设备运转效能下降
                      <br />降低每单位的能源成本
                    </span>
                  </div>
                  <div class="step_item">
                    <img class="img4" src="@assets/img/neng2.png" alt />
                    <span>减少浪费</span>
                    <span>
                      让能源使用情形公开透明
                      <br />找出异常能耗的原因
                      <br />消除习惯性浪费
                      <br />改善待机运转效率
                    </span>
                  </div>
                  <div class="step_item">
                    <img class="img4" src="@assets/img/neng3.png" alt />
                    <span>增加获利</span>
                    <span>
                      降低能源成本
                      <br />减少不必要的浪费
                      <br />提高生产力管理
                      <br />持续改善能源效率管理
                      <br />方面的可视化管理
                    </span>
                  </div>
                </div>
              </div>
              <div class="san" style="text-align:center">
                <img src="@assets/img/san.png" alt />
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="流体计量" name="third" class="animate__animated animate__fadeIn">
            <div class="container container3">
              <div class="title">
                从测量方式到能源使用等多方面考虑
                <br />全面降低能源成本
              </div>
              <div
                class="text"
              >目前，所有公司都在致力于有效使用和监控能源，降低能源成本。加热和冷却工艺、压缩空气、天然气电力和蒸汽等，在生产、分配和消费中产生日益增加的能耗成本。</div>
              <div
                class="text"
              >我们提供各类精准的测量仪表，包括监控表盘、监控柜、监控站、以及用于污水处理厂的曝气控制系统等等，科学的测量方式，以及相关的系统解决方案，为企业的成功打下坚定的基础。还可通过使用有意义的指标，对流体过程进行持续监控，为能源管理解决方案的具体实施提供更多可能。</div>
              <div class="icons">
                <div class="icon_item" v-for="(item,index) in liuIcon" :key="index">
                  <img :src="item.url" alt />
                  <span>{{item.theme}}</span>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="数据分析与校准服务" name="fourth" class="animate__animated animate__fadeIn">
            <div class="container container4">
              <div
                class="text"
                style="padding-top:0px"
              >通过连接所有数据、系统和过程，在正确的时间客户提供正确的信息。这些信息可以帮助客户预测即将发生的事情、预知即将发生的问题并让客户的业务联系更加紧密、高效和智能。</div>
              <ul>
                <li
                  v-for="(item,index) in contentList"
                  :key="index"
                  v-bind:style="{ 'background-image': 'url(' + item.url+ ')','background-repeat':'no-repeat', 'background-position':' left center'}"
                >
                  <!-- <div class="image">
                    <img :src="item.url" alt />
                  </div>-->
                  <div class="introduce">
                    <span class="theme">{{item.theme}}</span>
                    <span class="content" v-html="item.content">{{item.content}}</span>
                  </div>
                </li>
              </ul>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@components/header";
import Footer from "@components/footer";
export default {
  name: "Expertise",
  inject: ["reload"],
  components: {
    Header,
    Footer,
  },
  created() {
    this.banner_flag = true;
  },
  data() {
    return {
      headerList: [
        { name: "解决方案" },
        { name: "产品中心" },
        { name: "咨询服务" },
        { name: "专长" },
        { name: "了解我们" },
        { name: "加入我们" },
      ],
      jieList: [
        { name: "自动化", link: "" },
        { name: "物联", link: "" },
        { name: "能源", link: "" },
        { name: "环境", link: "" },
      ],
      chanList: [
        {
          name: "工业无线",
          detail: [
            { name: "无线网络", link: "" },
            { name: "无线通讯", link: "" },
            { name: "无线位置", link: "" },
            { name: "无限分析", link: "" },
          ],
        },
        {
          name: "工业软件",
          detail: [
            { name: "能源管理软件", link: "" },
            { name: "大数据平台", link: "" },
            { name: "GIS地图信息平台", link: "" },
          ],
        },
        {
          name: "测量仪表",
          detail: [
            { name: "流体仪表", link: "" },
            { name: "电力仪表", link: "" },
            { name: "压力仪表", link: "" },
            { name: "温度仪表", link: "" },
            { name: "液位仪表", link: "" },
          ],
        },
      ],
      ziList: [
        {
          name: "咨询",
          detail: [
            { name: "智能工厂设计咨询", link: "" },
            { name: "工业物联园区设计咨询", link: "" },
          ],
        },
        {
          name: "服务",
          detail: [
            { name: "设备安装与运维服务", link: "" },
            { name: "数据分析与校准服务", link: "" },
            { name: "能源与能效诊断服务", link: "" },
          ],
        },
      ],
      zhuanList: [
        { name: "跨学科研发", link: "" },
        { name: "物联", link: "" },
        { name: "工业无线", link: "" },
        { name: "流体测量", link: "" },
      ],
      liaoList: [
        { name: "企业概述", link: "" },
        { name: "企业文化", link: "" },
        { name: "荣誉资质", link: "" },
        { name: "新闻报告", link: "" },
        { name: "合作伙伴", link: "" },
      ],
      jiaList: [
        { name: "社会招聘", link: "" },
        { name: "校园招聘", link: "" },
      ],
      headerFlag: true,
      img1before: require("@assets/img/logob.png"),
      img2before: require("@assets/img/soub.png"),
      img3before: require("@assets/img/daob.png"),
      activeIndex: -1,
      modalFlag: false,
      rotate: false, //控制互转效果
      erweima: require("@assets/img/erma.png"),
      //   banner: require("@assets/img/banner2.jpg"),
      imgList: [
        {
          name: "能源",
          url: require("@assets/img/zhuan_zong.png"),
          spanFlag: true,
          maskFlag: false,
          content:
            "多学科技术与产品的完美融合，优化工厂运营的能源供应和能源需求。",
        },
        {
          name: "流体计量",
          url: require("@assets/img/zhuan_liu.png"),
          spanFlag: true,
          maskFlag: false,
          content: "从测量方式到能源使用等多方面考虑全面降低能源成本",
        },
        {
          name: "数据分析与校准服务",
          url: require("@assets/img/zhuan_shu.png"),
          spanFlag: true,
          maskFlag: false,
          content:
            "通过连接所有数据、系统和过程，在正确的时间客户您提供正确的信息。这些信息可以帮助客户预测即将发生的事情、预知即将发生的问题并让客户的业务联系更加紧密、高效和智能。",
        },
      ],
      contentList: [
        {
          theme: "校准服务",
          content:
            "收集和分析数据以产生可操作的关键绩效指标信息，使工厂人员能够快速识别存在的问题及原因，并实施纠正措施。",
          url: require("@assets/img/jiaozhun.png"),
        },
        {
          theme: "预防服务",
          content:
            "机器设备是事业的基石。分析运转数据，掌控故障征兆，便可更有效地进行维护保养。",
          url: require("@assets/img/yufang.png"),
        },
        {
          theme: "预测性服务",
          content:
            "通过预测性服务，使您能够持续改进过程性能，延长资产寿命并降低风险。我们遵循行之有效的方法，帮助您从运营中实现价值最大化。",
          url: require("@assets/img/yuce.png"),
        },
      ],
      innovateList: [
        {
          theme: "能源管理整合生产管理至关重要",
          content:
            "轻松部署与维护： 整合生产管理和能源管理的单一平台，可快速部建使用易于扩充、便于维护，并能顺利整合第三方软件和数据库。<br/>数据整合： 将现场实务与信息管理透过数字化进行同步整合，我们能无缝串流实时数据，协助用户落实卓越营运的愿景。",
          url: require("@assets/img/nengyuan.png"),
        },
        {
          theme: " 未来商机最重要的是<br/>缩短项目时程以及提供加值服务",
          content:
            "可定制和扩充的服务： 直觉式接口搭配简易设定工具和定制化仪表板，能提供可靠及弹性的加值服务，同时缩短项目时间、降低风险并节省成本。<br/>崭新的商业机会： 迅速导入项目及加值服务，可在市场取得竞争优势和新商机，以顺应未来趋势发展。",
          url: require("@assets/img/weilai.png"),
        },
      ],
      liuIcon: [
        { theme: "全系列高精准仪器仪表", url: require("@assets/img/liu1.png") },
        { theme: "实用多样的测量方式", url: require("@assets/img/liu2.png") },
        { theme: "量身定制的解决方案", url: require("@assets/img/liu3.png") },
        { theme: "经验丰富，技术可靠", url: require("@assets/img/liu4.png") },
        { theme: "持续降低能源成本", url: require("@assets/img/liu5.png") },
        {
          theme: "优化生产过程，提高设备效率",
          url: require("@assets/img/liu6.png"),
        },
      ],
      spanFlag: true,
      activeName: "first",
      banner_flag: false,
    };
  },
  mounted() {
    let Item_data = sessionStorage.getItem("expertise");
    // console.log(sessionStorage.getItem("item"))
    // switch (this.$route.params.tab) {
    switch (Item_data) {
      case "0":
        this.activeName = "first";
        break;
      case "1":
        this.activeName = "second";
        break;
      case "2":
        this.activeName = "third";
        break;
      case "3":
        this.activeName = "fourth";
        break;
      case "4":
        this.activeName = "fifth";
        break;
    }
  },

  methods: {
    handleToHome() {
      //点击图片跳转到首页
      this.$router.push("/");
      console.log(123);
    },
    enter: function () {
      this.headerFlag = false;
      this.img1before = require("@assets/img/logob.png");
      this.img2before = require("@assets/img/soub.png");
      this.img3before = require("@assets/img/daob.png");
      this.activeIndex = -1;
    },
    leave: function () {
      this.headerFlag = true;
      this.img1before = require("@assets/img/logob.png");
      this.img2before = require("@assets/img/soub.png");
      this.img3before = require("@assets/img/daob.png");
      this.activeIndex = -1;
    },
    selected(index) {
      this.activeIndex = index;
      console.log(this.activeIndex);
    },
    navShow(index) {
      console.log(index);
    },
    navNone(index) {
      console.log(index);
    },
    afterLoad(link, index) {
      console.log(link, index);
    },
    showAll() {
      //打开弹窗
      //点击右上角三条横杠
      this.modalFlag = true;
    },
    handleClose() {
      //关闭弹窗
      this.modalFlag = false;
      // this.$refs.fullpage.api.setAllowScrolling(true, "up,down,left, right");
    },
    zhuan() {
      //旋转模态框叉号
      this.rotate = !this.rotate;
    },
    // 面包屑
    handleHome() {
      this.$router.push("/");
    },
    handleEnter(index) {
      //滑上组件时字体消失 遮罩显示
      // this.spanFlag=false;
      // console.log(index)
      this.imgList[index].spanFlag = false;
      this.imgList[index].maskFlag = true;
    },
    handleLeave(index) {
      // console.log(index)
      this.imgList[index].spanFlag = true;
      this.imgList[index].maskFlag = false;
    },
    // 选项卡切换
    handleClick(tab) {
      // window.location.reload();
      sessionStorage.setItem("expertise", tab.index);
      this.reload();
      this.$refs.home.scrollIntoView();
    },
    handleClickTabs(index) {
      switch (index) {
        case 0:
          this.activeName = "second";
          break;
        case 1:
          this.activeName = "third";
          break;
        case 2:
          this.activeName = "fourth";
          break;
      }
      sessionStorage.setItem("expertise", index + 1);
      window.location.reload();
      this.$refs.home.scrollIntoView();
    },
  },
};
</script>

<style lang='scss' scoped>
.home {
  width: 100%;
  height: 100%;
  position: relative;
}

.banner {
  width: 100%;
  height: 500px;
  background: url("../../assets/img/banner_zhuanchang.png") no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: bottom center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  div {
    width: 75%;
    margin: 0 auto;
  }
  span {
    font-size: 26px;
    font-family: YaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    display: block;
    line-height: 44px;
    letter-spacing: 2px;
    // margin-left: 20%;
    &:nth-child(1) {
      font-size: 48px;
      font-family: YaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      letter-spacing: 4px;
      // padding-top: 15%;
      // padding-bottom: 18px;
    }
  }
}
.main {
  width: 100%;
  background: #f5f5f5;
  .main_center {
    width: 75%;
    height: 100%;
    margin: 0 auto;
    .bread {
      padding-top: 30px;
      padding-bottom: 80px;
      font-size: 16px;
      font-family: YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      cursor: default;
    }
    .tabs {
      width: 100%;
      .container {
        width: 100%;
        padding-top: 94px;
      }
      //能源
      .container2 {
        .step {
          width: 100%;
          // height: 515px;
          padding-bottom: 50px;
          background: #fbfbfb;
          margin-top: 88px;
          margin-bottom: 142px;
          .step_title {
            font-size: 32px;
            font-family: YaHei;
            font-weight: 400;
            color: #333333;
            text-align: center;
            padding-top: 60px;
            margin-bottom: 100px;
          }
          .step_items {
            display: flex;
            justify-content: space-around;
            flex-wrap: wrap;
            .step_item {
              // display: flex;
              // flex-direction: column;
              // justify-content: center;
              // align-items: center;
              text-align: center;
              width: 320px;
              margin-bottom: 50px;
              .img1 {
                width: 90px;
                height: 90px;
              }
              .img2 {
                width: 104px;
                height: 78px;
              }
              .img3 {
                width: 90px;
                height: 90px;
              }
              .img4 {
                width: 90px;
                height: 90px;
              }
              span {
                display: block;
                &:nth-child(1) {
                  font-size: 24px;
                  font-family: YaHei;
                  font-weight: 400;
                  color: #333333;
                  margin-right: 83px;
                }
                &:nth-child(3) {
                  font-size: 28px;
                  font-family: YaHei;
                  font-weight: 400;
                  color: #333333;
                  margin-top: 30px;
                  margin-bottom: 30px;
                }
                &:nth-child(4) {
                  font-size: 16px;
                  font-family: YaHei;
                  font-weight: 400;
                  color: #333333;
                }
              }
            }
            .shujv {
              margin-right: 150px !important;
              //  margin-top: -16px  !important;
            }
            .shujv1 {
              margin-top: 42px !important;
            }
          }
        }
        .innovate {
          .innovate_title {
            font-size: 32px;
            font-family: YaHei;
            font-weight: 400;
            color: #333333;
            text-align: center;
          }
          ul {
            width: 100%;
            padding-top: 82px;
            text-align: left;
            padding-bottom: 50px;
            li {
              min-height: 310px;
              width: 100%;
              display: flex;
              // background: pink;
              padding-top: 1%;
              padding-bottom: 1%;
              background-size: 50% 100%;
              background-repeat: no-repeat;
              background-position: left center;
              &:nth-child(2n) {
                background-position: right center !important;
                .introduce {
                  margin: 0;
                }
              }
              // justify-content:end;
              // align-items: center;
              // position: relative;
              // height: 307px;
              // padding-bottom: 20px;
              margin-bottom: 80px;
              // &:nth-child(2) {
              //   .image {
              //     right: 0;
              //   }
              //   .introduce {
              //     left: 0;
              //   }
              // }
              .image {
                width: 50%;
                height: 100%;
                overflow: hidden;
                // position: absolute;
                transition: all 0.6s !important;
                // // background: url("../../assets/img/banner1.jpg") no-repeat;
                // background-size: cover;
                // -webkit-background-size: cover;
                // -o-background-size: cover;
                // background-position: center bottom;
                // &:nth-child(1){
                //    background: url("../../assets/img/banner1.jpg") no-repeat;
                // }
                // &:nth-child(2){
                //    background: url("../../assets/img/banner2.jpg") no-repeat;
                // }
                // &:nth-child(3){
                //    background: url("../../assets/img/banner3.jpg") no-repeat;
                // }
                img {
                  width: 100%;
                }
                &:hover {
                  transform: scale(1.1);
                }
              }
              .introduce {
                // float: right;
                display: flex;
                flex-direction: column;
                justify-content: center;
                width: 52%;
                min-height: 80%;
                background: rgba(255, 255, 255, 1);
                box-sizing: border-box;
                text-align: left;
                padding: 29px 33px 31px 40px;
                margin-left: 48%;
                // position: absolute;
                // right: 0;
                // top: 10%;
                .theme {
                  display: block;
                  font-size: 30px;
                  font-family: Source Han Sans SC;
                  font-weight: 500;
                  color: rgba(51, 51, 51, 1);
                  margin-bottom: 23px;
                }
                .content {
                  font-size: 17px;
                  font-family: Source Han Sans SC;
                  font-weight: 500;
                  color: rgba(51, 51, 51, 1);
                  line-height: 29px;
                }
              }
            }
          }
        }
        .step1 {
          // height: 446px;
          text-align: center;
          .step_item {
            padding-top: 92px;
            span {
              display: block;
              &:nth-child(2) {
                font-size: 28px !important;
                font-family: YaHei;
                font-weight: 400;
                color: #333333;
                margin-top: 30px;
                margin-bottom: 30px;
              }
              &:nth-child(3) {
                font-size: 16px !important;
                font-family: YaHei;
                font-weight: 400;
                color: #333333;
                margin: 0 !important;
                line-height: 25px;
              }
            }
          }
        }
        .san {
          img {
            max-width: 80%;
          }
        }
      }
      //流体计量
      .container3 {
        padding-bottom: 50px;
        width: 100%;
        .icons {
          width: 100%;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          padding-top: 112px;
          // padding: 112px 0px 0px 171px;
          span {
            font-size: 24px;
            font-family: YaHei;
            font-weight: 400;
            color: #343434;
            display: block;
            margin-top: 20px;
          }
          .icon_item {
            width: 30%;
            // display: inline-block;
            // margin-right: 206px;
            margin-bottom: 65px;
            text-align: center;
            img {
              width: 100px;
            }
            // &:nth-child(2){
            //     margin-right: 170px;
            // }
            // &:nth-child(3) {
            //   margin-right: 0px;
            // }
            // &:nth-child(4) {
            //   margin-right: 229px;
            //   margin-left: 14px;
            // }
            // &:nth-child(5) {
            //   margin-right: 170px;
            // }
            // &:nth-child(6) {
            //   margin-right: 0px;
            // }
          }
        }
      }
      //数据分析与校准服务
      .container4 {
        ul {
          width: 100%;
          padding-top: 82px;
          text-align: left;
          padding-bottom: 105px;
          li {
            min-height: 310px;
            width: 100%;
            display: flex;
            // background: pink;
            padding-top: 1%;
            padding-bottom: 1%;
            background-size: 50% 100%;
            background-repeat: no-repeat;
            background-position: left center;
            &:nth-child(2n) {
              background-position: right center !important;
              .introduce {
                margin: 0;
              }
            }
            // justify-content:end;
            // align-items: center;
            // position: relative;
            // height: 307px;
            // padding-bottom: 20px;
            margin-bottom: 80px;
            // &:nth-child(2) {
            //   .image {
            //     right: 0;
            //   }
            //   .introduce {
            //     left: 0;
            //   }
            // }
            .image {
              width: 50%;
              height: 100%;
              overflow: hidden;
              // position: absolute;
              transition: all 0.6s !important;
              // // background: url("../../assets/img/banner1.jpg") no-repeat;
              // background-size: cover;
              // -webkit-background-size: cover;
              // -o-background-size: cover;
              // background-position: center bottom;
              // &:nth-child(1){
              //    background: url("../../assets/img/banner1.jpg") no-repeat;
              // }
              // &:nth-child(2){
              //    background: url("../../assets/img/banner2.jpg") no-repeat;
              // }
              // &:nth-child(3){
              //    background: url("../../assets/img/banner3.jpg") no-repeat;
              // }
              img {
                width: 100%;
              }
              &:hover {
                transform: scale(1.1);
              }
            }
            .introduce {
              // float: right;
              display: flex;
              flex-direction: column;
              justify-content: center;
              width: 52%;
              min-height: 80%;
              background: rgba(255, 255, 255, 1);
              box-sizing: border-box;
              text-align: left;
              padding: 29px 33px 31px 40px;
              margin-left: 48%;
              // position: absolute;
              // right: 0;
              // top: 10%;
              .theme {
                display: block;
                font-size: 30px;
                font-family: Source Han Sans SC;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                margin-bottom: 23px;
              }
              .content {
                font-size: 17px;
                font-family: Source Han Sans SC;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                line-height: 29px;
              }
            }
          }
        }
      }
    }
    /deep/ .is-active {
      color: #dcba79 !important;
    }
    /deep/ .el-tabs__active-bar {
      background-color: #dcba79;
      height: 2px;
    }
    /deep/ .el-tabs__item {
      font-size: 22px;
      padding-right: 80px;
    }
    /deep/ .el-tabs__nav {
      padding-bottom: 20px;
    }
    /deep/.el-tabs__item:hover {
      color: #333333; //修改鼠标移动到表头时候字体颜色，默认淡蓝色
      cursor: pointer; //鼠标移动到表头时候鼠标样式，默认小手
    }
    .title {
      font-size: 48px;
      font-family: YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      text-align: center;
    }
    .text {
      // width: 76%;
      margin: 0 auto;
      font-size: 24px;
      line-height: 44px;
      font-family: YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      padding-top: 33px;
      text-align: center;
    }
    .ul1 {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding-top: 124px;
      padding-bottom: 60px;
      li {
        cursor: pointer;
        position: relative;
        width: 380px;
        height: 310px;
        overflow: hidden;
        // background: rgba(255, 255, 255, 1);
        // border: 1px dashed rgba(51, 51, 51, 1);
        // margin-right: 140px;
        margin-bottom: 44px;
        img {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          // position: absolute;
          // transition: all 2s;
          // &:hover {
          //   transform: scale(
          //     1.1
          //   ); /*scale:图片放大几倍；translateX,translateY:放大后图片的位移*/
          //   // border: 1px solid #999;
          // }
        }
        &:nth-child(3) {
          margin-right: 0px;
        }
        .name {
          position: absolute;
          bottom: 0;
          width: 380px;
          height: 76px;
          background: rgba(255, 255, 255, 1);
          // transition: all 3s;
          span {
            font-size: 30px;
            font-family: Source Han Sans SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            line-height: 76px;
            margin-left: 24px;
          }
        }
        //  &:hover .name{
        //    display: none;
        //    position: relative;
        //    transition: all 3s;
        //  }
        .mask {
          width: 380px;
          height: 310px;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          background: rgba(51, 51, 51, 0.5);
          // opacity: 0.5;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          span {
            display: block;
            &:nth-child(1) {
              // margin: 100px 35px 32px;
              font-size: 30px;
              font-family: YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              margin-bottom: 25px;
            }
            &:nth-child(2) {
              font-size: 18px;
              font-family: YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              width: 306px;
              // margin-left: 35px;
            }
          }
        }
      }
    }
  }
}
</style>

